import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import "./theme/fonts.css";
import "./theme/tokens.css";
import "./theme/base.css";
import "./theme/components.css";
import "./theme/system.css";
import { applyTheme, getTheme } from "./theme/theme";

applyTheme(getTheme());
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
